/**
 * @generated SignedSource<<45f5ce1316a4a6943b0263a30961dc88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerScopedTokenDialog_ownerInfo$data = {
  readonly platform: string;
  readonly uid: string;
  readonly " $fragmentType": "OwnerScopedTokenDialog_ownerInfo";
};
export type OwnerScopedTokenDialog_ownerInfo$key = {
  readonly " $data"?: OwnerScopedTokenDialog_ownerInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerScopedTokenDialog_ownerInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerScopedTokenDialog_ownerInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "d183984583f158642ec6eae6cba5f26c";

export default node;
